<script>
    export let title = "Zadaným parametrom neodpovedá žiadna pneumatika v našej ponuke."
</script>

<div class="error-content">
    <img alt="Error" class="img-fluid" src="/assets/img/error-crying.webp">
    <h3>{title}</h3>
</div>